import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ArcConvertedFileDto {
  @Field()
  filePath!: string

  @Field()
  fileName!: string

  @Field(t => Int)
  fileSize!: number

  kindleOptimizationsAdded!: boolean

  errors?: string
}
